// extracted by mini-css-extract-plugin
module.exports = {"container":"Accommodations_container__I2rzh","markdown":"Accommodations_markdown__z_Gyj"};